import React, { useEffect } from "react";
import { useGameController } from "./hooks/useGameController.ts";
import { Box, Sky } from "@react-three/drei";
import { useFrame, useLoader } from "@react-three/fiber";
import { Color, Vector3 } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import Fire from "./effects/Fire.tsx";
import { applyRealisticMaterials } from "./utils/materialUtils.ts";

export default function MenuScene() {

    const gameController = useGameController();
    const gltf = useLoader(GLTFLoader, "data/models/menu.gltf");

    useEffect(()=>{
        gameController.getAudioController().playAudio("background",0.2,1,true);
        //gameController.getAudioController().playAudio("fire",1,1,true);
        return () => {
            gameController.getAudioController().pauseAudio("background");
            //gameController.getAudioController().pauseAudio("fire");
        }
    },[])

    useEffect(() => {
        // Apply realistic materials to menu scene
        if (gltf?.scene) {
            applyRealisticMaterials(gltf.scene);
        }
    }, [gltf]);

    useFrame(({ camera }) => {
        //rotate camera around the center
        const radius = 100;
        camera.position.set(Math.cos(Date.now() * 0.0002) * radius,100,Math.sin(Date.now() * 0.0002) * radius);
        camera.lookAt(1,1,-1);
        camera.updateProjectionMatrix();
    });
    return (
        <>
            {/* Bright but less warm menu lighting */}
            <ambientLight intensity={0.6} color="#f5f5dc"/>
            <directionalLight 
                position={[50, 50, 25]} 
                intensity={1.8} 
                color="#fff8e7"
                castShadow
                shadow-mapSize-width={1024}
                shadow-mapSize-height={1024}
            />
            <directionalLight 
                position={[-30, 40, -20]} 
                intensity={0.5} 
                color="#f0f8ff"
            />
            {/*<Fire position={[0.35, 0.35, -1.2]} />*/}
            <primitive object={gltf.scene} receiveShadow castShadow/>
        </>
    );
}